var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeregyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "17 139.6 83.1 80.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 {\n            fill: #5C5C5C;\n        }\n\n        .st1 {\n            fill: #73B043;\n        }\n\n        .st2 {\n            fill: #195E88;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41.6,189.3 29.9,182.7 17.1,189.9 28.9,196.5 28.9,209.9 41.6,202.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.5,160.8 70.2,154.2 70.2,139.8 58.5,146.4 46.8,139.8 46.8,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,189.5 75.4,202.5 88.1,209.7 88.1,196.5 99.9,189.9 87.2,182.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "75.4,170.3 87.2,177 100,169.8 88.1,163.1 88.1,149.9 75.4,157.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.6,198.9 46.8,205.6 46.8,219.8 58.5,213.2 70.2,219.8 70.2,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "41.6,170.3 41.6,157.1 28.9,149.9 28.9,163.1 17.2,169.7 29.9,176.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeregyStar);
export default __webpack_public_path__ + "static/media/veregy-star.9e21011c93dde60cf2627eb951afb7d8.svg";
export { ForwardRef as ReactComponent };